export default {"src":"/_next/static/media/Virtuoso.2a56d6a8.gif","height":972,"width":1971};